// API Base URL - Uses environment variable in production, falls back to localhost for development
// REACT_APP_API_URL is the primary canonical variable; REACT_APP_BACKEND_URL is retained for backward compatibility.
const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000";
export default API_BASE_URL;